"use client";
import { RefObject } from "react";
import styles from "./modals.module.css";
import { useTranslations } from "next-intl";
import { MdClose } from "react-icons/md";
import { useMyListingsStore } from "../../../useMyListingsStore";

export default function SoldModal({
  dialogRef,
  handleClose,
}: {
  dialogRef: RefObject<HTMLDivElement | null>;
  handleClose: () => void;
}) {
  const t = useTranslations("SoldModal");
  const { setSoldOnDoomum } = useMyListingsStore();
  return (
    <div
      ref={dialogRef}
      className={styles.contentWrapper}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className={styles.closeButton}
        onClick={(e) => {
          e.preventDefault();
          handleClose();
        }}
      >
        <MdClose />
      </button>
      <h3>Was this property sold through Doomum?</h3>
      <p className={styles.description}>
        This helps us understand whether Doomum played a role in the sale before
        continuing with removing the listing.
      </p>
      <p className={styles.step}>{t("step", { stepNumber: "1/2" })}</p>
      <div className={styles.buttonsWrapper}>
        <button
          className={styles.btn}
          onClick={(e) => {
            e.preventDefault();
            setSoldOnDoomum(false);
          }}
        >
          {t("no")}
        </button>
        <button
          className={styles.btn}
          onClick={(e) => {
            e.preventDefault();
            setSoldOnDoomum(true);
          }}
        >
          {t("yes")}
        </button>
      </div>
    </div>
  );
}
